module.exports = "#ifdef USE_DECALMAP\n  vDecalUv = (decalUVTransform * vec3(uv, 1.0)).xy;\n#endif\n";